import script from "./LoginB.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginB.vue?vue&type=script&setup=true&lang=js"

import "./LoginB.vue?vue&type=style&index=0&id=0ea51e86&lang=less"

const __exports__ = script;

export default __exports__